import axios from "axios";
import {
  GET_ALL_BOOKINGS_VALUE,
  GET_ALL_BOOKING_BY_COMPANY_ID,
  CHECK_PLAN,
  GET_BOOKING_FIELD_LIST,
} from "../constants";
import { ApiCall } from "../../utils/index";
import { Collaborator, Customer } from "../../constant/AuthenticationConstant";
import { downloadExcel } from "../../utils/index";

export const getAllBookingsByCompanyId =
  (searchText, page, rowsPerPage, sort_by, sort_order, request) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = searchText ? `search=${searchText}` : "";
      let params = `?${searchParam}&page=${page}&page_size=${rowsPerPage}&sort_field=${sort_by}&sort_order=${sort_order}`;
      if (type === Customer) {
        params += `&type=${type}`;
      }
      const result = await ApiCall.get(
        `/activityAssignment/booking_list${params}`,
        token
      );
      dispatch({
        type: GET_ALL_BOOKING_BY_COMPANY_ID,
        payload: result.data,
      });
      request.onSuccess();
    } catch (err) {
      request.onError();
    }
  };

export const exportBookingTableData =
  (searchText, page, rowsPerPage, sort_by, sort_order) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token, type },
      } = getState();
      const searchParam = searchText ? `search=${searchText}` : "";
      let params = `?${searchParam}&page=${page}&page_size=${rowsPerPage}&sort_field=${sort_by}&sort_order=${sort_order}`;
      if (type === Customer) {
        params += `&type=${type}`;
      }
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/activityAssignment/export${params}`,
        {
          authorization: `Bearer ${token}`,
          responseType: "blob", // Important: ensures the response is treated as a binary file
        }
      );

      downloadExcel(result, "Booking")
      
    } catch (err) {
      console.log('error -', err)
    }
  };

export const getBookingFieldList = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(
      "/activityAssignment/booking_field/list",
      token
    );
    dispatch({ type: GET_BOOKING_FIELD_LIST, payload: result.data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteBookingById =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(
        `/activityAssignment/${activity_assignment_id}`,
        token
      );
      cb(result.data);
    } catch (err) {
      cb(err);
    }
  };

export const createBookings =
  (bookingtempid, configid, refnum, newjson, tabledata, customerId, cb) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const units = tabledata.map((ele) => ({
        asset_type_id: ele.asset_type_id,
        quantity: ele.quantity,
        remarks: ele.remarks
      }));
      // console.log("payload ==>",  {
      //   booking_template_id: bookingtempid,
      //   configuration_id: configid,
      //   reference_no: refnum,
      //   booking_fields: newjson,
      //   units: units,
      //   customer_id: customerId,
      // })
      const result = await ApiCall.post(
        "/activityAssignment/booking",
        {
          booking_template_id: bookingtempid,
          configuration_id: configid,
          reference_no: refnum,
          booking_fields: newjson,
          units: units,
          customer_id: customerId,
        },
        token
      );
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const getActivityAssignmentIdByBookingId =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/activityAssignment/booking/${activity_assignment_id}`,
        token
      );

      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const getValueByBookingTemplateId =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/activityAssignment/booking_values/${activity_assignment_id}`,
        token
      );
      dispatch({
        type: GET_ALL_BOOKINGS_VALUE,
        payload: result.data,
      });
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const updateBooking =
  (updatedjson, assignmentid, initialCustomerId, customer, cb) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let payload;
      const booking_fields = [];
      updatedjson.forEach((ele, i) => {
        booking_fields.push({
          booking_template_custom_field_id:
            ele.booking_template_custom_field_id,
          component_id: ele.booking_template_custom_field?.component_id,
          value: ele.value,
          activity_assignment_id: ele.booking_id,
          booking_id: "",
        });
        if (ele.booking_control_id !== undefined) {
          booking_fields[i].booking_control_id = ele.booking_control_id;
        }
      });
      if (!initialCustomerId) {
        payload = {
          booking_fields,
          activity_assignment_id: assignmentid,
          customer_id: customer?.value,
        };
      } else {
        payload = {
          booking_fields,
        };
      }
      const result = await ApiCall.patch(
        `/activityAssignment/update/booking`,
        payload,
        token
      );

      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const checkPlanDetails = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      "/company/check/plan",
      request.data,
      token
    );
    dispatch({ type: CHECK_PLAN, payload: result.exceeds });
  } catch (error) {
    request.onError();
  }
};

export const uploadBookingFile =
  (activity_assignment_id, payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, company },
      } = getState();
      const result = await ApiCall.postFormData(
        `/activityAssignment/booking/file_upload/${activity_assignment_id}`,
        payload,
        token
      );
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const deleteBookingFile =
  (booking_file_upload_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, company },
      } = getState();
      const result = await ApiCall.delete(
        `/activityAssignment/booking/file_upload/${booking_file_upload_id}`,
        token
      );
      cb(result);
    } catch (error) {
      cb(error);
    }
  };
